import { SetStateAction, Dispatch } from 'react';

const errorMsg = `There was an error - please contact support@healthera.co.uk if you have any concerns, we're always happy to help.`;

const errorRoutine = (
  err: any,
  setApiErr: Dispatch<SetStateAction<string | undefined>>
) => {
  if (typeof err === 'string') return setApiErr(err);
  err?.text
    ? setApiErr(err.text)
    : err?.response?.data?.error
    ? setApiErr(err.response.data.error.text)
    : err?.message
    ? setApiErr(err.message + '.' + errorMsg)
    : setApiErr(errorMsg);
};

export default errorRoutine;
